export default __webpack_public_path__ + "static/dashboard3-91088bb4e099518f8b07ec9abddaca1c.png";